import { Grid, TextField, IconButton ,Button, Typography} from "@material-ui/core"
import { message, Upload } from "antd"
import Dragger from "antd/lib/upload/Dragger"
import React, { useEffect, useRef, useState } from "react"
import useStyles from "src/app/maintenance/assets/styles"
import { DeleteFileDialog } from "src/app/maintenance/test-automation/step6/KnowledgeBasedUploads"
import { hasUserPermission } from "src/app/permission"
import { UploadIcon, DocumentIcon, PenIcon, TrashIcon } from "src/components/Icons"
import { DragDrop } from "src/components/sub-components/DragAndDrop"

export const EditFiles = (
    { files,setFiles,fileList,setFileList,removeAFile,setIsDeleteConformation,isDeleteConformation, fileIndex,setFileIndex,setDeleteFileType,deleteFileType,errors ,setErrors,setDeleteFileList,setUploadedFile,
        setIsToasterOpen,setReqSuccess,setToasterMessage
    }) => {
    const classes = useStyles()
    const [selectedFile,setSelectedFile] = useState({})
    const [selectedFileName,setSelectedFileName] = useState('')
    const [isEdit,setIsEdit] = useState(false)
    const [editedFileName,setEditedFileName] = useState('')
    const spanRefs = useRef([])
    const [inputWidth,setInputWidth] = useState(0)

    useEffect(() =>{
        console.log(fileList)
    },[fileList])

    const handleFileChange = (info) => {
        // Filter out any files that already exist in the file list
        const currentFiles = Array.isArray(files) ? files : [];
        const newFiles = info.fileList.filter(file => {
                const existingFile = currentFiles.some(f => f.name === file.name);
                console.log(existingFile)
                if (existingFile) {
                    setIsToasterOpen(true);
                    setReqSuccess(false);
                    setToasterMessage("This file has already been attached.");
                    console.log('exist')
                }
                return !existingFile; // Only include files that are not already in the state
        }).map(file => ({
            name: file.name,
            size: (file.size / 1024 / 1024).toFixed(2),
            progress: 0,
            file: file.originFileObj,
        }));
        console.log(newFiles)
        if (newFiles.length > 0) {
            setUploadedFile(prev => [...prev, ...newFiles])
            setFileList(prev => [...prev, ...newFiles]);
            setErrors((prevError) => ({
                ...prevError,
                KnowledgedBase : null
            }))
        }

        setTimeout(() =>{
            setIsToasterOpen(false)
        },2500)
    };

    const props = {
        name: 'file',
        multiple: false,
        accept: '.pdf',
        onChange: handleFileChange,
        beforeUpload: (file) => {
            const isPdf = file.type === 'application/pdf';
            const isLt5MB = file.size / 1024 / 1024 < 5;
            const { status, name, size } = file;

            if (!isPdf) {
                message.error('You can only upload PDF files!');
                return false;
            }
            return false;
        },
        showUploadList: false
    };

    const handleCancelDelete = () =>{
        setIsDeleteConformation(false)
    }

    const handleDeleteButton = (file,index) =>{
        setIsDeleteConformation(true)
        setSelectedFile(file)
        setSelectedFileName(file.name)
        setDeleteFileList((prevFile) =>([
            ...prevFile,
            file.name
        ]))
        setFileIndex(index)
        setDeleteFileType('removeAFile')
    }

    const handleEditIcon = (index,name) =>{
        setIsEdit(true)
        setFileIndex(index)
        setEditedFileName(name)
        setErrors(prevError =>({
            ...prevError,
            fileError:null
        }))
        if (spanRefs.current[index]) {
            setInputWidth(spanRefs.current[index].offsetWidth); // Add padding
        }
    }

    const handleUpdateFileName = (newName, index) => {
        let updatedFiles = [...fileList];
        let updatedFileNames = updatedFiles.map(file => file.name);
        
        // Check if the new name already exists (excluding the current file)
        let findNameAlreadyExist = updatedFileNames.find((name, idx) => 
            name.toLowerCase() === newName.toLowerCase() && idx !== index
        );
        console.log(files,newName)
        // let nameExist = files.find((name, idx) => 
        //     name === newName
        // );
        // console.log(nameExist)
        let updatedFileErrors = { ...errors.fileError };

        if (findNameAlreadyExist) {
            updatedFileErrors[index] = "There is already a file with the same name. Please use another name.";
        } else {
            updatedFileErrors[index] = null; // Clear the error for this file if no conflict
        }
        
        // Check if all file errors are null, and set fileError to null if true
        const allErrorsNull = Object.values(updatedFileErrors).every(error => error === null);

        setErrors(prevError => ({
            ...prevError,
            fileError: allErrorsNull ? null : updatedFileErrors // Clear fileError if all errors are null
        }));
        if (!findNameAlreadyExist) {
            updatedFiles[index].name = newName;
        }
    };
    
    
    const handleFileNameChange = (e,index) => {
        const value = e.target.value

        setEditedFileName(e.target.value); // Update local state with the new file name
        let updatedFileErrors = { ...errors.fileError }
        if(value == ''){
            updatedFileErrors[index] = "File name can't be empty"
        }else{
            updatedFileErrors[index] = null
        }
        const allErrorsNull = Object.values(updatedFileErrors).every(error => error === null);

        setErrors(prevError => ({
            ...prevError,
            fileError: allErrorsNull ? null : updatedFileErrors // Clear fileError if all errors are null
        }));
    };
    
    const handleBlurOrEnter = () => {
        setIsEdit(false); // Disable edit mode
        handleUpdateFileName(editedFileName, fileIndex); // Save the updated filename
    };

    return (
        <Grid container style={{margin:'15px 0px'}}>
            {fileList && fileList.length > 0 && (
                <Grid item xs={12} md={12} style={{ display: 'flex', justifyContent: 'flex-end' }} >
                    <Upload {...props} accept='.pdf'>
                        <Button
                            variant="outlined"
                            startIcon={<UploadIcon color='#2A7BEC' />}
                            className={classes.button}
                            style={{ borderColor: '#2A7BEC', color: '#2A7BEC' }}
                        >
                            Attach Files
                        </Button>
                    </Upload>
                </Grid>
            )}
            <Grid item xs={12} md={12}>
                <Grid container style={{ marginTop: '15px', maxHeight: '450px', overflowY: 'auto' }}>
                    {fileList && fileList.length > 0 ? (
                        fileList.map((file, index) => (
                            <Grid container key={index}>
                                <Grid container  direction='column' style={{ border: '1px solid #CACACA', borderRadius: '4px', padding: '10px', marginTop: '15px' ,backgroundColor:'#FFFFFF'}}>
                                    <Grid item xs={12} md={12}>
                                        <Grid container justifyContent='space-between'>
                                            <Grid item style={{ width: 'auto', display: 'flex', alignItems: 'center' }}>
                                                <DocumentIcon />
                                                {isEdit && fileIndex == index ? (
                                                    <TextField
                                                        value={editedFileName}
                                                        onChange={(e) => handleFileNameChange(e,index)}
                                                        onBlur={handleBlurOrEnter} // Save on blur (click outside)
                                                        onKeyPress={(e) => {
                                                            if (e.key === 'Enter') handleBlurOrEnter(); // Save on Enter key press
                                                        }}
                                                        autoFocus // Automatically focus the input when editing
                                                        InputProps={{
                                                            style: { width:`${inputWidth}px`,margin:'0px 10px', }, // Set width for input element
                                                        }}
                                                    />
                                                )
                                                    :
                                                    (
                                                        <span ref={(el) => (spanRefs.current[index] = el)} style={{ color: '#353535', textAlign: 'center', fontFamily: 'Poppins', margin: '0 10px' }}>
                                                            {file.name}
                                                        </span>
                                                    )

                                                }
                                                <IconButton size="small" onClick={() => handleEditIcon(index, file.name)}>
                                                    <PenIcon />
                                                </IconButton>

                                            </Grid>
                                            <Grid item>
                                                <IconButton size="small" onClick={() => handleDeleteButton(file, index)}>
                                                    <TrashIcon />
                                                </IconButton>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item style={{ color: '#B4B2B2', textAlign: 'center', fontFamily: 'Poppins', display: 'flex' }}>
                                        {`${file.size} MB`}
                                    </Grid>
                                    {/* <Grid item xs={12} md={12} style={{ display: 'flex' }}>
                                        <progress value={file.progress} max={100} style={{ width: '100%', marginRight: '10px' }} />
                                        <span>{`${file.progress}%`}</span>
                                    </Grid> */}
                                </Grid>
                                {errors.fileError && fileIndex == index &&
                                    <Grid item xs={12} style={{ padding: "0px 8px" ,textAlign:'left'}}>
                                        <Typography className={classes.errorText} >
                                            {errors.fileError[index]}
                                        </Typography>
                                    </Grid>
                                }
                            </Grid>

                        ))
                    )
                :
                (
                    <Grid container>
                        <Grid item className={classes.dragDrop} style={{borderColor:errors.KnowledgedBase ? 'red':'#CBD0DC',width:'100%'}}>
                            <Dragger {...props} accept='.pdf' onChange={handleFileChange} disabled={!hasUserPermission("KNOWLEDGE_BASE_UPLOADS.FILE_UPLOAD", "ADD")} >
                                <DragDrop />
                                <p className={classes.dragText} style={{textAlign:'center'}}>Click or drag file to this area to upload</p>
                                {/* <p className="ant-upload-text" style={{ color: '#B4B2B2', textAlign: 'center' }}>maximum upload file size : 5MB</p> */}
                            </Dragger>
                        </Grid>
                        {errors.KnowledgedBase &&
                            <Grid item xs={12} style={{ padding: "0px 8px" ,textAlign:'left'}}>
                                <Typography className={classes.errorText} >
                                    {errors.KnowledgedBase}
                                </Typography>
                            </Grid>
                        }
                    </Grid>
                )}
                </Grid>
            </Grid>
            <DeleteFileDialog 
                open={isDeleteConformation} 
                fileName={selectedFileName} 
                onClose={handleCancelDelete} 
                onDelete={removeAFile}
                type={deleteFileType}
            />
        </Grid>
    )
}